var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseButton',_vm._g(_vm._b({attrs:{"small":"","block":"","color":_vm.computedColor,"text-color":_vm.computedTextColor,"md-icon":_vm.mdIcon,"md-icon-position":"left"}},'BaseButton',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }